import React from "react";

const DteSystemStatusHeader: React.FC = () => {
  return (
    <div className="space-y-2 mb-4">
      <h2 className="text-xl font-semibold text-black dark:text-white">
        Estado del Sistema DTE
      </h2>

      <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
        El sistema activa el <strong>Modo Contingencia</strong> automáticamente cuando 
        el Ministerio de Hacienda no está disponible. Desde aquí puedes activarlo o 
        desactivarlo de forma <strong>manual</strong> para pruebas o casos especiales.
      </p>
    </div>
  );
};

export default DteSystemStatusHeader;
